import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/SearchPage.vue'),
        children: [{
            path: 'registrado',
            name: 'registered',
        }]
    },
    {
        path: '*',
        component: () => import('@/views/404.vue')
    },
    {
        path: '/landing',
        name: 'landing',
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/politica-de-privacidade.pdf',
        name: 'privacy',
        component: () => import('@/views/PrivacyPolicies.vue')
    },
    {
        path: '/termos-de-uso.pdf',
        name: 'terms',
        component: () => import('@/views/TermsOfUse.vue')
    },
    {
        path: '/cadastro/:name?/:email?',
        name: 'register-user',
        component: () => import('@/views/RegisterUser.vue')
    },
    /* {
        path: '/meu-negocio',
        name: 'admin',
        component: () => import('@/views/Shop_admin.vue')
    }, */
    {
        path: '/meu-negocio/', //:shop_url
        component: () => import('@/views/shopadmin/Main.vue'),
        children: [
            {
                path: 'mensagens',
                name: 'admin/messages',
                component: () => import('@/views/shopadmin/Messages.vue')
            },
            {
                path: 'editar',
                name: 'admin/edit',
                component: () => import('@/views/shopadmin/Edit.vue')
            },
            {
                path: '',
                name: 'admin/home',
                component: () => import('@/views/shopadmin/Products.vue')
            },
        ]
    },
    /*{
        path: '/meu-negocio/:shop_url/caixa',
        name: 'admin/about',
        component: () => import('@/views/Admin_messages.vue')
    },
    {
        path: '/meu-negocio/:shop_url/editar',
        name: 'admin/edit',
        component: () => import('@/views/Admin_edit.vue')
    },*/
    {
        path: '/criar-negocio',
        name: 'register-shop',
        component: () => import('@/views/RegisterShop.vue')
    },
    {
        path: '/negocio/:shop_url',
        name: 'shop',
        component: () => import('@/views/Shop.vue')
    },
    {
        path: '/perfil',
        name: 'profile',
        component: () => import('@/views/Profile.vue')
    },
    {
        path: '/usuario/:user',
        name: 'profile_user',
        component: () => import('@/views/Profile_Share.vue')
    },
    {
        path: '/perfil/editar',
        name: 'profile_edit',
        component: () => import('@/views/Profile_edit.vue')
    },
    {
        path: '/produto/:shop_url/:product_url',
        name: 'product',
        component: () => import('@/views/Product.vue')
    },
    {
        path: '/busca/:searchQuery',
        name: 'search',
        component: () => import('@/views/SearchResults.vue')
    },
    {
        path: '/nova-senha',
        name: 'newPassword',
        component: () => import('@/views/NewPassword.vue')
    },
    {
        path: '/dicas',
        name: 'tips',
        component: () => import('../views/Tips.vue')
    },
    {
        path: '/suporte',
        name: 'support',
        component: () => import('../views/Support.vue')
    },
    {
        path: '/lancamento',
        name: 'launch',
        component: () => import('../views/Counter.vue')
    },
    /*{
        path: '/novo-negocio',
        name: 'newBusiness',
        component: () => import('../views/NewBusiness.vue')
    },*/
    {
        path: '/error404',
        name: 'error404',
        component: () => import('../views/404.vue')
    },
    {
        path: '/Map',
        name: 'map',
        component: () => import('../views/MapPage.vue')
    },
]

const router = new VueRouter({
    mode: "history",
    routes,
})

export default router